export const testimonials = [
  {
    name: "Mara Hilpert",
    type: "Web Designer",
    avatar: "/images/content/avatar-4.jpg",
    review: [
      {
        author: "Megane Schumm",
        description: "Legacy Data Coordinator",
        logo: "/images/content/goldlines.svg",
        image: "/images/content/testimonials-pic.jpg",
        image2x: "/images/content/testimonials-pic@2x.jpg",
        comment:
          "Stacks is the cleanest design system I’ve used. It helps a lot of projects done without thinking. Nice Work! ",
      },
    ],
  },
  {
    name: "Kaylah Botsford",
    type: "Web Designer",
    avatar: "/images/content/avatar-5.jpg",
    review: [
      {
        author: "Megane Schumm",
        description: "Legacy Data Coordinator",
        logo: "/images/content/velocity9.svg",
        image: "/images/content/testimonials-pic.jpg",
        image2x: "/images/content/testimonials-pic@2x.jpg",
        comment:
          "Stacks is the cleanest design system I’ve used. It helps a lot of projects done without thinking.",
      },
    ],
  },
  {
    name: "Reinhold Ullrich",
    type: "Web Designer",
    avatar: "/images/content/avatar-2.jpg",
    review: [
      {
        author: "Megane Schumm",
        description: "Legacy Data Coordinator",
        logo: "/images/content/goldlines.svg",
        image: "/images/content/testimonials-pic.jpg",
        image2x: "/images/content/testimonials-pic@2x.jpg",
        comment:
          "Stacks is the cleanest design system I’ve used. It helps a lot of projects done without thinking. Nice Work!",
      },
    ],
  },
  {
    name: "Josh Bartoletti",
    type: "Web Designer",
    avatar: "/images/content/avatar-3.jpg",
    review: [
      {
        author: "Megane Schumm",
        description: "Legacy Data Coordinator",
        logo: "/images/content/goldlines.svg",
        image: "/images/content/testimonials-pic.jpg",
        image2x: "/images/content/testimonials-pic@2x.jpg",
        comment:
          "Stacks is the cleanest design system I’ve used. It helps a lot of projects done without thinking. Nice Work!",
      },
    ],
  },
];
